<template>
  <Modal
    :modalTitle="'Upload File'"
    :modalSize="'modal-lg'"
    :id="'galleryModal'"
    :ref="'modalRef'"
  >
    <div class="card text-dark">
      <div class="px-4 d-flex justify-content-end">
        <button
          @click="openHeroModal()"
          data-bs-dismiss="modal"
          class="btn btn-danger"
        >
          X
        </button>
      </div>
      <input type="hidden" id="slideIndex" value="" />
      <input type="hidden" id="modal_id" value="" />
      <div class="card-body">
        <label class="form-label float-left speedee-bold">Search Image: </label>
        <input type="text" class="form-control" id="search" v-model="search" />
      </div>
      <div class="card-body gallery-container">
        <div v-for="(gallery, index) in galleries" :key="index">
          <button @click="addImage(gallery.id, gallery.image_url)">
            <div class="image-container bg-light text-dark">
              <img :src="gallery.image_thumb_url" />
              <!-- <img :src="gallery.image_url" /> -->
              {{ gallery.name }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ModalComponent.vue";
import { ref, onMounted, watch } from "vue";
import { getRequest } from "@/services/RequestService";

export default {
  components: {
    Modal,
  },
  props: {
    modalId: String,
    visible: Boolean,
  },

  setup() {
    const galleries = ref([]);
    const search = ref("");

    const getGalleries = async (searchTerm = "") => {
      let response = await getRequest(`/galleries?search=${searchTerm}`);
      galleries.value = response.data.data.photos;
    };

    onMounted(() => {
      console.log("onMounted hook executed");
      getGalleries();
    });

    watch(search, (newSearchTerm, oldSearchTerm) => {
      getGalleries(newSearchTerm);
    });

    return {
      getGalleries,
      galleries,
      search,
    };
  },

  methods: {
    openHeroModal() {
      let modalName = document.getElementById("modal_id").value;
      var firstModal = document.getElementById(modalName);
      var galleryModal = document.getElementById("galleryModal");

      if (modalName && firstModal) {
        galleryModal.classList.remove("show");
        galleryModal.style.display = "none";

        firstModal.classList.add("show");
        firstModal.style.display = "block";
      } else {
        galleryModal.classList.remove("show");
        galleryModal.style.display = "none";
      }
    },

    addImage(galleryId, galleryUrl) {
      let modalName = document.getElementById("modal_id").value;

      // Get the slide index
      let index = document.getElementById("slideIndex").value;
      this.$emit("add-image", { galleryId, index, galleryUrl, modalName });

      this.openHeroModal();
    },
  },
};
</script>

<style scoped>
/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  padding: 20px;
  border-radius: 8px;
}

/* Additional styles to center the button */
button {
  margin-top: 20px;
}

.gallery-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
}

.image-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 200px;
  height: 150px;
  padding: 10px;
  margin: 10px;
  overflow: hidden;
  border: 1px;
  gap: 4px;
  font-size: 0.8em;
}

.image-container img {
  width: 180px;
  height: 120px;
  object-fit: contain;
  align-self: center;
}
</style>